import React, { useState } from 'react';

import {
    AlertDialog,
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Text,
    IconButton,
    Stack,
    Divider,
} from 'shell/components';

const DialogDemo = () => {
    const [dialog, setDialog] = useState({
        open: false,
    });
    const [scrollDialog, setScrollDialog] = useState({
        open: false,
    });
    const [alertDialog, setAlertDialog] = useState({
        open: false,
        message: 'Message',
        description: 'Description of alert.',
        note: '',
        variant: 'primary',
        actionButtonText: 'Action',
        cancelButtonText: 'Cancel',
    });

    return (
        <>
            <Text variant={'sh1'}>Dialog</Text>
            <Button onClick={() => setDialog({ open: true })}>Open Dialog</Button>
            <Button onClick={() => setScrollDialog({ open: true })}>Open Scroll Dialog (w/ Header and Footer)</Button>
            <Button
                onClick={() =>
                    setAlertDialog((current) => ({
                        ...current,
                        note: '',
                        open: true,
                        variant: 'primary',
                    }))
                }
            >
                Open Alert Dialog
            </Button>
            <Button
                onClick={() =>
                    setAlertDialog((current) => ({
                        ...current,
                        note: 'Note: Add any notes here.',
                        open: true,
                        variant: 'primary',
                    }))
                }
            >
                Open Alert Dialog With Note
            </Button>
            <Button
                onClick={() =>
                    setAlertDialog((current) => ({
                        ...current,
                        note: '',
                        open: true,
                        variant: 'destructive',
                    }))
                }
            >
                Open Destructive Alert Dialog
            </Button>
            <Button
                onClick={() =>
                    setAlertDialog((current) => ({
                        ...current,
                        note: 'Note: Add any notes here.',
                        open: true,
                        variant: 'destructive',
                    }))
                }
            >
                Open Destructive Alert Dialog With Note
            </Button>
            <Dialog open={dialog.open} onClose={() => setDialog({ open: false })}>
                <Box>
                    <Text>Hello World!</Text>
                </Box>
            </Dialog>
            <Dialog
                sx={{
                    '& .MuiDialog-paper': {
                        width: '100%',
                        height: '100%',
                    },
                }}
                open={scrollDialog.open}
                scroll={'paper'}
                onClose={() => setScrollDialog({ open: false })}
            >
                <DialogTitle>
                    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                        <Text>DialogTitle</Text>
                        <IconButton
                            kind={'exit'}
                            size={'medium'}
                            variant={'square'}
                            onClick={() => setScrollDialog({ open: false })}
                        />
                    </Stack>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Text>DialogContent</Text>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Stack direction={'row'} spacing={4}>
                        <Button disabled variant={'secondary'}>
                            Back
                        </Button>
                        <Button>Next</Button>
                    </Stack>
                </DialogActions>
            </Dialog>
            <AlertDialog
                message={alertDialog.message}
                description={alertDialog.description}
                note={alertDialog.note}
                open={alertDialog.open}
                variant={alertDialog.variant}
                actionButtonText={alertDialog.actionButtonText}
                cancelButtonText={alertDialog.cancelButtonText}
                onAction={() => setAlertDialog((current) => ({ ...current, open: false }))}
                onCancel={() => setAlertDialog((current) => ({ ...current, open: false }))}
                onClose={() => setAlertDialog((current) => ({ ...current, open: false }))}
            />
        </>
    );
};

export default DialogDemo;
